export default __webpack_public_path__ + "static/media/Nursing.49b292f4.png";